/**
 * Quality Inspector Service
 * API service for quality inspector operations
 */

import api from './api';

class InspectorService {
    // ============================================================================
    // PROFILE MANAGEMENT
    // ============================================================================

    async getMyProfile() {
        try {
            const response = await api.get('/inspectors/profile/me');
            return response.data;
        } catch (error) {
            console.error('Get my profile error:', error);
            throw error;
        }
    }

    async updateMyProfile(profileData) {
        try {
            const response = await api.put('/inspectors/profile/me', profileData);
            return response.data;
        } catch (error) {
            console.error('Update profile error:', error);
            throw error;
        }
    }

    async updateAvailability(isAvailable) {
        try {
            const response = await api.put('/inspectors/availability', { isAvailable });
            return response.data;
        } catch (error) {
            console.error('Update availability error:', error);
            throw error;
        }
    }

    // ============================================================================
    // INSPECTIONS MANAGEMENT
    // ============================================================================

    async getMyInspections(filters = {}) {
        try {
            const queryParams = new URLSearchParams(filters).toString();
            const response = await api.get(`/inspectors/inspections/my?${queryParams}`);
            return response.data;
        } catch (error) {
            console.error('Get my inspections error:', error);
            throw error;
        }
    }

    async getInspectionDetails(inspectionId) {
        try {
            const response = await api.get(`/inspectors/inspections/${inspectionId}`);
            return response.data;
        } catch (error) {
            console.error('Get inspection details error:', error);
            throw error;
        }
    }

    async startInspection(inspectionId) {
        try {
            const response = await api.post(`/inspectors/inspections/${inspectionId}/start`);
            return response.data;
        } catch (error) {
            console.error('Start inspection error:', error);
            throw error;
        }
    }

    async completeInspection(inspectionId, data) {
        try {
            const response = await api.post(`/inspectors/inspections/${inspectionId}/complete`, data);
            return response.data;
        } catch (error) {
            console.error('Complete inspection error:', error);
            throw error;
        }
    }

    // ============================================================================
    // STATISTICS & ANALYTICS
    // ============================================================================

    async getMyStats() {
        try {
            const response = await api.get('/inspectors/stats/my');
            return response.data;
        } catch (error) {
            console.error('Get stats error:', error);
            throw error;
        }
    }

    // ============================================================================
    // EARNINGS
    // ============================================================================

    async getMyEarnings(filters = {}) {
        try {
            const queryParams = new URLSearchParams(filters).toString();
            const response = await api.get(`/inspectors/earnings/my?${queryParams}`);
            return response.data;
        } catch (error) {
            console.error('Get earnings error:', error);
            throw error;
        }
    }

    // ============================================================================
    // REPORTS
    // ============================================================================

    async getMyReports(filters = {}) {
        try {
            const queryParams = new URLSearchParams(filters).toString();
            const response = await api.get(`/inspectors/reports/my?${queryParams}`);
            return response.data;
        } catch (error) {
            console.error('Get reports error:', error);
            throw error;
        }
    }

    // ============================================================================
    // CERTIFICATIONS
    // ============================================================================

    async getMyCertifications() {
        try {
            const response = await api.get('/inspectors/certifications/my');
            return response.data;
        } catch (error) {
            console.error('Get certifications error:', error);
            throw error;
        }
    }

    // ============================================================================
    // PUBLIC DIRECTORY
    // ============================================================================

    async getAllInspectors(filters = {}) {
        try {
            const queryParams = new URLSearchParams(filters).toString();
            const response = await api.get(`/inspectors?${queryParams}`);
            return response.data;
        } catch (error) {
            console.error('Get all inspectors error:', error);
            throw error;
        }
    }

    async getInspectorById(inspectorId) {
        try {
            const response = await api.get(`/inspectors/${inspectorId}`);
            return response.data;
        } catch (error) {
            console.error('Get inspector by ID error:', error);
            throw error;
        }
    }
}

const inspectorService = new InspectorService();
export default inspectorService;
